<ul class="additionSection">
<li>
  <label>
    Section {{i+1}}
  </label>
    <div class="dataField">
      <input type="text" #sectionInput class="textBox" [readonly]="!storyEditMode" placeholder="Add Section here."
        [(ngModel)]="sectionQuery" (keyup)="filterAutoCompleteUp($event ,'section')" (keydown)="filterAutoCompleteDown($event ,'section')"
        (focus)="focusInSuggest('section', i)" (focusout)="false">
      <ng-container *ngIf="storyEditMode && insideAddedSection === true">
        <ng-container *ngIf="currentSelectedSection === i">
          <div #sectionList class="autosuggestion block" *ngIf="filteredNewSectionSuggestion && filteredNewSectionSuggestion.length > 0 ">
            <ul *ngFor="let item of filteredNewSectionSuggestion;let i = index">
              <li (click)="selectAutoComplete('section', item)" [class.active]="i === currentSelection">
                <span class="name">{{item}}</span>
                <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
              </li>
            </ul>
          </div>
        
        <ng-container *ngIf="insideAddedSection && (1 > filteredNewSectionSuggestion.length)">
          <div class="autosuggestion block">
            <ul>
              <li>
                <span class="name">No Results</span>
              </li>
            </ul>
          </div>
        </ng-container>
      </ng-container>
      </ng-container>
    </div>
</li>
<ng-container *ngIf="addedSection['section'] !== ''">
<li>
  <label>
    Sub Section {{i+1}}
  </label>
    <div class="dataField">
      <input type="text" class="textBox" #subSectionInput  [readonly]="!storyEditMode" placeholder="Add Sub Section here."
        [(ngModel)]="subSectionQuery" (keyup)="filterAutoCompleteUp($event ,'subSection')" (keydown)="filterAutoCompleteDown($event ,'subSection')"
        (focus)="focusInSuggest('subSection', i)" (focusout)="false">
        <ng-container *ngIf="storyEditMode && insideAddedSubsection === true">
          <ng-container *ngIf="currentSelectedSection === i">
            <div #subSectionList class="autosuggestion block" *ngIf="filteredNewSubsectionSuggestion && filteredNewSubsectionSuggestion.length > 0 ">
                <ul *ngFor="let item of filteredNewSubsectionSuggestion;let i = index">
                  <li (click)="selectAutoComplete('subSection', item)" [class.active]="i === currentSelection">
                    <span class="name">{{item}}</span>
                    <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                  </li>
                </ul>
              </div>
          </ng-container>
        </ng-container>
        
        <ng-container *ngIf="insideAddedSubsection && (1 > filteredNewSubsectionSuggestion.length)">
          <div class="autosuggestion block">
            <ul>
              <li>
                <span class="name">No Results</span>
              </li>
            </ul>
          </div>
        </ng-container>
    </div>
</li>
</ng-container>
</ul>


